/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from "./index";


export function getEnumList(property, callback) {
  return APIRequest('get','/lora/enum/'+property, {}, {}, callback);
}

export function getDeviceList(args, callback) {
  return APIRequest('get', '/lora/nodes', args, {}, callback);
}

export function editDeviceDetail(device_id, data, callback) {
  return APIRequest('put', '/lora/nodes/'+device_id, {}, data, callback);
}

export function addDevice(
  deveui,
  devaddr,
  type,
  city,
  area,
  status,
  callback
) {
  return APIRequest('post','/lora/devices', {}, {
    deveui: deveui,
    devaddr: devaddr,
    type: type,
    city: city,
    area: area,
    status: status
  }, callback);
}

export function editDevice(id,property,value,callback) {
  return APIRequest('post','/lora/devices/'+id, {}, {
    property:value
  }, callback);
}

export function getDeviceDetail(device_id,callback) {
  return APIRequest('get','/lora/nodes/'+device_id, {}, {}, callback);
}

export function addOTAA(appeui, deveui, appkey, band = '', callback) {
  return APIRequest('post', '/lora/nodes', {}, {
    appeui: appeui,
    deveui:deveui,
    appkey: appkey,
    fcntbits: 32,
    band,
  }, callback);
}

export function importABP(devaddr, nwkskey, appskey, deveui, AppEUI, band, callback) {
  return APIRequest('post','/lora/nodes', {}, {
    devaddr: devaddr,
    nwkskey: nwkskey,
    appskey: appskey,
    deveui: deveui,
    appeui: AppEUI,
    fcntbits: 32,
    band,
  }, callback);
}
export function delDevice(device_id,callback) {
  return APIRequest('del','/lora/nodes/'+device_id, {}, {}, callback);
}

export function delData(device_id,callback) {
  return APIRequest('post','/lora/nodes/'+device_id + "/tx/flush", {}, {}, callback);
}
export function getDataSize(device_id,args,callback) {
  return APIRequest('get','/lora/nodes/'+device_id + "/tx/size",args, {}, callback);
}
export function sendData(device_id,data,fport,callback) {
  return APIRequest('post','/lora/nodes/'+device_id + "/tx", {}, {
    data:data,
    fport:fport,
  }, callback);
}

//export function getDeviceOnQuery(args,callback) {
//  return APIRequest('get','/lora/nodes', args, {}, callback);
//}

export function getAppDeviceLogRecord(appid,args,callback) {
  return APIRequest('get','/lora/applications/'+appid+'/logs',args, {}, callback);
}

export function getAppLogs(id, args, cb) {
  return APIRequest('get', `/lora/applications/${id}/logs`, args, {}, cb);
}
// 'get','/devlog/history?src=lora&appeui='+appid,args, {}, callback
//  GET /v1/lora/applications/#ID/logs

export function getDeviceMacLog(device_id,args,callback) {
  return APIRequest('get','/lora/nodes/'+device_id+"/mac/logs?deveui="+device_id,args, {}, callback);
}

export function getDeviceLog(args,callback) {
  return APIRequest('get','/devlog/history',args, {}, callback);
}

export function importBatch(sourceObj,appid,callback) {  //{list:[object,object,object]}
  return APIRequest('post','/lora/nodes/batch', {}, {
    app: appid,
    list: sourceObj.list
  }, callback);
}
export function getApplicationCount(appid, callback) {
  return APIRequest('get','/lora/nodes/count?app='+ appid,{}, {}, callback);
}

export function dviceStatistics(id, MILLSN, MILLSL, callback) {
  return APIRequest('get', '/lora/nodes/' + id + '/stats?from=' + MILLSN + '&to=' + MILLSL , {}, {}, callback);
}
export function rxqosStatistics(id, callback) {
  return APIRequest('get', '/lora/nodes/' + id + '/rxqos?download' , {}, {}, callback);
}

export function getDeviceCount(appid, callback) {
  return APIRequest('get','/lora/nodes/count?app='+ appid,{}, {}, callback);
}
export function getOrgBasic(callback) {
  return APIRequest('get','/org/basic',{}, {}, callback);
}
export function getNodesCount(callback) {
  return APIRequest('get','/lora/nodes/count',{}, {}, callback);
}

export function writeRegister(devid, port, registerId, value, callback) {
  const registers = {};
  registers[registerId] = value;
  return APIRequest(
    'post',
    `/lora/nodes/${devid}/registers`,
    {},
    { port, registers, op: 'write' },
    callback,
  );
}

export function readRegister(devid, port, registerId, callback) {
  const registers = [registerId];
  return APIRequest(
    'post',
    `/lora/nodes/${devid}/registers`,
    {},
    { port, registers, op: 'read' },
    callback,
  );
}

export function getRegisterLogs(devid, query, callback) {
  return APIRequest(
    'get',
    `/lora/nodes/${devid}/registers/logs`,
    query,
    {},
    callback,
  );
}




// WEBPACK FOOTER //
// ./src/api/lora_device.js